import { api } from '@/api';

// Role Permission Mapping interface for the new API response
export interface RolePermissionMapping {
  uuid: string;
  role: string;
  permission: string;
  role_name: string;
  permission_name: string;
  permission_description: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
  is_deleted: boolean;
}

// API Response interface for paginated role permission mappings
export interface RolePermissionMappingsResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: RolePermissionMapping[];
}

// Legacy interfaces for backward compatibility (if needed for form)
export interface Role extends Record<string, unknown> {
  uuid: string;
  role_name: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface Permission extends Record<string, unknown> {
  uuid: string;
  permission_name: string;
  description: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface CreateRolePermissionPayload {
  role: string;
  permission: string;
}

export interface CreateRolePermissionResponse {
  success: boolean;
  message: string;
  data: {
    id?: string;
    role?: string;
    permission?: string;
  };
}

export const rolePermissionsService = {
  // New method for getting paginated role permission mappings
  async getRolePermissionMappings(page: number = 1, pageSize: number = 15): Promise<RolePermissionMappingsResponse> {
    const params = new URLSearchParams({
      page: page.toString(),
      page_size: pageSize.toString(),
    });

    const response = await api.get<RolePermissionMappingsResponse>(`/backoffice/api/v1/role-permissions/?${params.toString()}`);
    return response as unknown as RolePermissionMappingsResponse;
  },

  // Legacy method for backward compatibility (if needed for form)
  async getRolePermissions(): Promise<RolePermissionMappingsResponse> {
    const response = await api.get<RolePermissionMappingsResponse>('/backoffice/api/v1/role-permissions/');
    return response as unknown as RolePermissionMappingsResponse;
  },

  async createRolePermission(payload: CreateRolePermissionPayload): Promise<CreateRolePermissionResponse> {
    const response = await api.post<CreateRolePermissionResponse>('/backoffice/api/v1/role-permissions/', payload);
    return response as unknown as CreateRolePermissionResponse;
  },

  deleteRolePermission: async (uuid: string) => {
    const response = await api.delete(
      `/backoffice/api/v1/role/${uuid}/`
    );
    return response.data;
  },
};

export default rolePermissionsService;
